document.addEventListener('DOMContentLoaded', function () {

  document
    .querySelectorAll('[data-tb-antique-product]')
    .forEach(function (root) {


      /* =====================================================
         ELEMENTS
      ====================================================== */

      const mainImage =
        root.querySelector('[data-tbap-main-image]');

      const thumbs =
        Array.from(
          root.querySelectorAll('[data-tbap-thumb]')
        );

      const zoomButton =
        root.querySelector('[data-tbap-zoom]');

      const lightbox =
        root.querySelector('[data-tbap-lightbox]');

      const lightboxImage =
        root.querySelector('[data-tbap-lightbox-image]');

      const closeButton =
        root.querySelector('[data-tbap-close]');

      const readMore =
        root.querySelector('[data-tbap-read-more]');

      const description =
        root.querySelector('[data-tbap-description]');

      const readLabel =
        root.querySelector('[data-tbap-read-label]');

      const readArrow =
        root.querySelector('[data-tbap-read-arrow]');



      /* =====================================================
         GALLERY
      ====================================================== */

      function setMainImage(url, alt, activeMediaId) {

        if (!mainImage || !url) return;

        mainImage.src = url;

        mainImage.removeAttribute('srcset');

        mainImage.alt = alt || '';


        if (lightboxImage) {

          lightboxImage.src = url;
          lightboxImage.alt = alt || '';

        }


        thumbs.forEach(function (thumb) {

          thumb.classList.toggle(
            'is-active',
            activeMediaId &&
            String(thumb.dataset.mediaId) === String(activeMediaId)
          );

        });

      }


      thumbs.forEach(function (thumb) {

        thumb.addEventListener('click', function () {

          const url =
            thumb.dataset.image;

          const alt =
            thumb.dataset.alt || '';

          const mediaId =
            thumb.dataset.mediaId;


          setMainImage(
            url,
            alt,
            mediaId
          );

        });

      });



      /* =====================================================
         LIGHTBOX
      ====================================================== */

      function openLightbox() {

        if (!lightbox || !mainImage) return;


        if (lightboxImage) {

          lightboxImage.src =
            mainImage.currentSrc ||
            mainImage.src;

          lightboxImage.alt =
            mainImage.alt || '';

        }


        lightbox.classList.add('is-open');

        lightbox.setAttribute(
          'aria-hidden',
          'false'
        );

        document.body.classList.add(
          'tbap-lightbox-open'
        );

      }


      function closeLightbox() {

        if (!lightbox) return;


        lightbox.classList.remove('is-open');

        lightbox.setAttribute(
          'aria-hidden',
          'true'
        );

        document.body.classList.remove(
          'tbap-lightbox-open'
        );

      }


      zoomButton
        ?.addEventListener(
          'click',
          openLightbox
        );


      closeButton
        ?.addEventListener(
          'click',
          closeLightbox
        );


      lightbox
        ?.addEventListener(
          'click',
          function (event) {

            if (
              event.target === lightbox
            ) {

              closeLightbox();

            }

          }
        );


      document.addEventListener(
        'keydown',
        function (event) {

          if (
            event.key === 'Escape'
          ) {

            closeLightbox();

          }

        }
      );



      /* =====================================================
         READ MORE
      ====================================================== */

      if (
        readMore &&
        description
      ) {

        readMore.addEventListener(
          'click',
          function () {

            const expanded =
              readMore.getAttribute(
                'aria-expanded'
              ) === 'true';


            readMore.setAttribute(
              'aria-expanded',
              expanded
                ? 'false'
                : 'true'
            );


            description.classList.toggle(
              'is-expanded',
              !expanded
            );


            if (readLabel) {

              readLabel.textContent =
                expanded
                  ? 'Read more'
                  : 'Read less';

            }


            if (readArrow) {

              readArrow.textContent =
                expanded
                  ? '↓'
                  : '↑';

            }

          }
        );

      }



      /* =====================================================
         ACCORDION SYMBOLS
      ====================================================== */

      root
        .querySelectorAll(
          '.tbap__accordion'
        )
        .forEach(
          function (accordion) {

            accordion.addEventListener(
              'toggle',
              function () {

                const symbol =
                  accordion.querySelector(
                    '.tbap__accordion-symbol'
                  );


                if (symbol) {

                  symbol.textContent =
                    accordion.open
                      ? '−'
                      : '+';

                }

              }
            );

          }
        );



      /* =====================================================
         VARIANT PICKER
      ====================================================== */

      const variantsJson =
        root.querySelector(
          '[data-tbap-variants-json]'
        );


      if (!variantsJson) return;


      let variants = [];


      try {

        variants =
          JSON.parse(
            variantsJson.textContent
          );

      } catch (error) {

        console.error(
          'TallBoy antique variant JSON error:',
          error
        );

        return;

      }


      const optionButtons =
        Array.from(
          root.querySelectorAll(
            '[data-tbap-option]'
          )
        );


      /*
       * No visible variant options means this is
       * a normal one-off antique.
       */

      if (!optionButtons.length) {
        return;
      }


      const variantInput =
        root.querySelector(
          '[data-tbap-variant-id]'
        );

      const priceElement =
        root.querySelector(
          '[data-tbap-price]'
        );

      const availability =
        root.querySelector(
          '[data-tbap-availability]'
        );

      const availabilityText =
        root.querySelector(
          '[data-tbap-availability-text]'
        );

      const addButton =
        root.querySelector(
          '[data-tbap-add-button]'
        );

      const addLabel =
        root.querySelector(
          '[data-tbap-add-label]'
        );



      /* =====================================================
         MONEY
      ====================================================== */

      function formatMoney(cents) {

        return new Intl.NumberFormat(
          'en-GB',
          {
            style: 'currency',
            currency: 'GBP'
          }
        ).format(
          cents / 100
        );

      }



      /* =====================================================
         CURRENT OPTION VALUES
      ====================================================== */

      function selectedOptions() {

        const selected = {
          1: null,
          2: null,
          3: null
        };


        root
          .querySelectorAll(
            '[data-tbap-option].is-selected'
          )
          .forEach(
            function (button) {

              selected[
                Number(
                  button.dataset.optionPosition
                )
              ] =
                button.dataset.optionValue;

            }
          );


        return selected;

      }



      /* =====================================================
         FIND VARIANT
      ====================================================== */

      function findVariant() {

        const selected =
          selectedOptions();


        return variants.find(
          function (variant) {

            if (
              selected[1] !== null &&
              variant.option1 !== selected[1]
            ) {
              return false;
            }


            if (
              selected[2] !== null &&
              variant.option2 !== selected[2]
            ) {
              return false;
            }


            if (
              selected[3] !== null &&
              variant.option3 !== selected[3]
            ) {
              return false;
            }


            return true;

          }
        );

      }



      /* =====================================================
         UPDATE OPTION HEADING
      ====================================================== */

      function updateOptionLabel(
        position,
        value
      ) {

        const label =
          root.querySelector(
            '[data-tbap-selected-option="' +
            position +
            '"]'
          );


        if (label) {

          label.textContent =
            value;

        }

      }



      /* =====================================================
         UPDATE URL
      ====================================================== */

      function updateUrl(variant) {

        if (
          !variant ||
          !window.history ||
          !window.history.replaceState
        ) {

          return;

        }


        const url =
          new URL(
            window.location.href
          );


        url.searchParams.set(
          'variant',
          variant.id
        );


        window.history.replaceState(
          {},
          '',
          url.toString()
        );

      }



      /* =====================================================
         UPDATE AVAILABILITY
      ====================================================== */

      function updateAvailability(
        variant
      ) {

        if (!availability) return;


        let dot =
          availability.querySelector(
            '.tbap__availability-dot'
          );


        if (
          variant &&
          variant.available
        ) {

          if (!dot) {

            dot =
              document.createElement(
                'span'
              );

            dot.className =
              'tbap__availability-dot';

            availability.prepend(
              dot
            );

          }


          if (availabilityText) {

            availabilityText.textContent =
              'Available';

          }

        } else {

          if (dot) {
            dot.remove();
          }


          if (availabilityText) {

            availabilityText.textContent =
              variant
                ? 'Sold'
                : 'Unavailable';

          }

        }

      }



      /* =====================================================
         UPDATE BUTTON
      ====================================================== */

      function updateButton(
        variant
      ) {

        if (!addButton) return;


        if (
          !variant ||
          !variant.available
        ) {

          addButton.disabled =
            true;


          if (addLabel) {

            addLabel.textContent =
              variant
                ? 'Sold'
                : 'Unavailable';

          }

        } else {

          addButton.disabled =
            false;


          if (addLabel) {

            addLabel.textContent =
              'Add to basket';

          }

        }

      }



      /* =====================================================
         UPDATE VARIANT IMAGE
      ====================================================== */

      function updateVariantImage(
        variant
      ) {

        if (
          !variant ||
          !variant.featured_image ||
          !mainImage
        ) {

          return;

        }


        const image =
          variant.featured_image;


        mainImage.src =
          image.url1800 ||
          image.url;


        mainImage.srcset =
          [
            image.url800 + ' 800w',
            image.url1200 + ' 1200w',
            image.url1600 + ' 1600w',
            image.url1800 + ' 1800w'
          ].join(', ');


        mainImage.alt =
          image.alt || '';


        if (lightboxImage) {

          lightboxImage.src =
            image.url;

          lightboxImage.alt =
            image.alt || '';

        }


        if (
          variant.featured_media_id
        ) {

          thumbs.forEach(
            function (thumb) {

              thumb.classList.toggle(
                'is-active',
                String(
                  thumb.dataset.mediaId
                ) ===
                String(
                  variant.featured_media_id
                )
              );

            }
          );

        }

      }



      /* =====================================================
         UPDATE COMPLETE PRODUCT
      ====================================================== */

      function updateProduct() {

        const variant =
          findVariant();


        if (!variant) {

          updateAvailability(null);

          updateButton(null);

          return;

        }


        /*
         * Variant ID
         */

        if (variantInput) {

          variantInput.value =
            variant.id;

        }


        /*
         * Price
         */

        if (priceElement) {

          priceElement.textContent =
            formatMoney(
              variant.price
            );

        }


        /*
         * Availability
         */

        updateAvailability(
          variant
        );


        /*
         * Basket button
         */

        updateButton(
          variant
        );


        /*
         * Image
         */

        updateVariantImage(
          variant
        );


        /*
         * Browser URL
         */

        updateUrl(
          variant
        );


        /*
         * Shopify theme event
         */

        root.dispatchEvent(
          new CustomEvent(
            'tbap:variant-change',
            {
              detail: {
                variant: variant
              }
            }
          )
        );

      }



      /* =====================================================
         OPTION CLICK
      ====================================================== */

      optionButtons.forEach(
        function (button) {

          button.addEventListener(
            'click',
            function () {

              const position =
                button.dataset.optionPosition;

              const value =
                button.dataset.optionValue;


              root
                .querySelectorAll(
                  '[data-tbap-option]' +
                  '[data-option-position="' +
                  position +
                  '"]'
                )
                .forEach(
                  function (sibling) {

                    sibling.classList.remove(
                      'is-selected'
                    );

                    sibling.setAttribute(
                      'aria-pressed',
                      'false'
                    );

                  }
                );


              button.classList.add(
                'is-selected'
              );


              button.setAttribute(
                'aria-pressed',
                'true'
              );


              updateOptionLabel(
                position,
                value
              );


              updateProduct();

            }
          );

        }
      );


      /*
       * Ensure everything starts in sync.
       */

      updateProduct();

    });

});